var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card--basic"},[_c('div',{staticClass:"card--section"},[_c('div',{staticClass:"card--section--title"},[_vm._t("sectionTitle"),_vm._v(" "),_vm._t("actions")],2),_vm._v(" "),_c('div',{staticClass:"grid grid-responsive"},[_vm._t("sectionContent")],2)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f1661fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/settings/SectionCard.vue
// module id = F+td
// module chunks = 0 1